export default __webpack_public_path__ + "static/media/Audio-Number-5.43c350c6.mp3";